<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <circle cx="24" cy="24" r="24" fill="#FEDF89" />
    <path
      d="M30 14L34 18M14 34L15.2764 29.3199C15.3597 29.0145 15.4013 28.8619 15.4652 28.7195C15.522 28.5931 15.5917 28.4729 15.6733 28.3609C15.7652 28.2348 15.8771 28.1229 16.1009 27.8991L26.4343 17.5657C26.6323 17.3677 26.7313 17.2687 26.8455 17.2316C26.9459 17.1989 27.0541 17.1989 27.1545 17.2316C27.2687 17.2687 27.3677 17.3677 27.5657 17.5657L30.4343 20.4343C30.6323 20.6323 30.7313 20.7313 30.7684 20.8455C30.8011 20.9459 30.8011 21.0541 30.7684 21.1545C30.7313 21.2687 30.6323 21.3677 30.4343 21.5657L20.1009 31.8991C19.8771 32.1229 19.7652 32.2348 19.6391 32.3267C19.5271 32.4083 19.4069 32.478 19.2805 32.5348C19.1381 32.5987 18.9855 32.6403 18.6801 32.7236L14 34Z"
      stroke="#7A2E0E"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
